import React, { useEffect } from 'react';
import { TileSleekGridGroup } from '../../shared/components/tileSleekGridGroup';
import { NavigationButtons } from '../../shared/components/navigationButtons';
import { TypographyH1 } from './style';
import { BoxStyled } from '../estimatingRequirements/esLandingScreen/style';
import { muscleScreenTileData } from '../../shared/shared.constants';
import { customPalette } from '../../styles/palette';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { setRouteArr, setRouteObj } from '../../store/slices/metaDataSlice';
import { useDispatch } from 'react-redux';

export const MuscleScreening = () => {
  const dispatch = useDispatch();
  const { optedOptions } = useAppSelector(metaDataSelector);
  const { routeArr, routeObj } = optedOptions;
  useEffect(() => {
    if (routeArr.length) {
      dispatch(
        setRouteArr(routeArr.filter((item) => item !== '/muscle-screening'))
      );
      dispatch(setRouteObj({ ...routeObj, muscle_screening: false }));
    }
  }, []);

  return (
    <>
      <TypographyH1
        sx={{
          fontFamily: 'BGRegular',
          fontWeight: 'bolder',
          color: customPalette.primaryDark,
          fontSize: '1.625rem',
          lineHeight: '1.875rem',
          textAlign: 'center',
          width: '55%',
          paddingTop: '1.5rem'
        }}
        className={'width-75'}
      >
        Muscle Assessment Tools
      </TypographyH1>
      <BoxStyled>
        <TileSleekGridGroup tileData={muscleScreenTileData} />
      </BoxStyled>
      <NavigationButtons
        nextDisabled={false}
        nextRoute={''}
        nextVisible={false}
      />
    </>
  );
};
